import HelloSign from 'hellosign-embedded';
import { SigningOutcome } from 'utils/signing/constants';

/**
 * Opens the HelloSign embedded signing widget and resolves once the session
 *   ends. Extracted verbatim from `requestForm$` so both providers share one
 *   shape; behaviour is intentionally unchanged.
 *
 * Rejects when HelloSign emits `error`, which `requestForm$` turns into
 *   `requestFormFailure`.
 */
export const openHelloSignEmbed = (signUrl: string): Promise<SigningOutcome> =>
  new Promise((resolve, reject) => {
    const helloSign = new HelloSign();

    const teardown = (settle: () => void) => () => {
      helloSign.off('close');
      helloSign.off('cancel');
      helloSign.off('finish');
      helloSign.off('sign');
      helloSign.off('error');
      settle();
    };

    const cancel = teardown(() => resolve(SigningOutcome.Cancelled));
    const success = teardown(() => resolve(SigningOutcome.Signed));
    const failure = teardown(() =>
      reject(new Error('HelloSign embedded signing failed')),
    );

    helloSign.on('close', cancel);
    helloSign.on('cancel', cancel);
    helloSign.on('finish', cancel);
    helloSign.on('sign', () => {
      success();
    });
    helloSign.on('error', failure);

    helloSign.open(signUrl, {
      clientId: import.meta.env.VITE_HELLOSIGN_CLIENT_ID,
      skipDomainVerification: true,
    });
  });
